import {actionNames} from 'constants/index';
const mapDispatchToProps = dispatch => ({
    MODULO_FALLECIDOS_SET_TAB: (tabModuloMenu)=> 
        dispatch({ "type":actionNames.MODULO_FALLECIDOS_SET_TAB,"state":{"tabModuloMenu":tabModuloMenu}}),        
    MODULO_FALLECIDOS_SET_MENU: (arrayMenu)=> 
        dispatch({ "type":actionNames.MODULO_FALLECIDOS_SET_MENU,"state":{"arrayMenu":arrayMenu}}),        
    MODULO_FALLECIDOS_SET_PRIMER_RENDER: (firstRender)=> 
        dispatch({ "type":actionNames.MODULO_FALLECIDOS_SET_PRIMER_RENDER,"state":{"firstRender":firstRender}}),        
});
export default mapDispatchToProps;